export default __webpack_public_path__ + "static/media/avatar.a3875fbc.svg";